import axios from "../../Axios/Default";
import { authUser, authUserSSO} from "../../Services/AuthService";
import Swal from "sweetalert2";

export const AUTH_SUCCESS = "AUTH_SUCCESS";
export const AUTH_LOGOUT = "AUTH_LOGOUT";
export const UPDATE_IMAGE = "UPDATE_IMAGE";

export const logout = (navigate) => dispatch => {
    delete axios.defaults.headers.common['Authorization'];
    localStorage.removeItem('access_token');
    localStorage.removeItem('refresh_token');
    dispatch({ type: AUTH_LOGOUT });
    localStorage.setItem('last_path', window.location.pathname);
    navigate("/login");
}

export const login = (navigate, payload, onError = err => { }) => dispatch => {
    authUser(payload, res => {
        const { userid, username, nik, fullname, email, phone, position, department, job_status, job_title, office, cost_center, role_id, role_name, avatar, access_token, refresh_token, access } = res.data;

        localStorage.setItem('access_token', access_token);
        localStorage.setItem('refresh_token', refresh_token);
        axios.defaults.headers.common['Authorization'] = `Bearer ${access_token}`;
        localStorage.removeItem('avatar');
        const userInfo = { userid, username, nik, fullname, email, phone, position, department, job_status, job_title, office, cost_center, role_id, role_name, avatar, access_token, refresh_token, access };

        Swal.fire({
            icon: 'success',
            title: 'Succes!',
            text: 'Login succes, please wait for a while, system will be redirected to the home page',
            timer: 1500,
            timerProgressBar: true,
            didOpen: () => {
                Swal.showLoading()
            }
        }).then(r => {
            dispatch({ type: AUTH_SUCCESS, userInfo });
            const last_path = localStorage.getItem('last_path');
            if (last_path) {
                const path = last_path.replace('login', 'dashboard').split('/').slice(0, 6).join('/');
                navigate(path);
                localStorage.removeItem('last_path');
            } else {
                navigate('/dashboard')
            }
        })
    }, onError);
}

export const authSSO = (navigate, payload, onError = err => { }) => dispatch => {
    authUserSSO(payload, async res => {
        const { userid, username, nik, fullname, email, phone, position, department, job_status, job_title, office, cost_center, role_id, role_name, avatar, access_token, refresh_token, access } = res.data;

        localStorage.setItem('access_token', access_token);
        localStorage.setItem('refresh_token', refresh_token);
        axios.defaults.headers.common['Authorization'] = `Bearer ${access_token}`;
        localStorage.removeItem('avatar');
        const userInfo = { userid, username, nik, fullname, email, phone, position, department, job_status, job_title, office, cost_center, role_id, role_name, avatar, access_token, refresh_token, access };

        Swal.fire({
            icon: 'success',
            title: 'Succes!',
            text: 'Login succes, please wait for a while, system will be redirected to the home page',
            timer: 1500,
            timerProgressBar: true,
            didOpen: () => {
                Swal.showLoading()
            }
        }).then(r => {
            dispatch({ type: AUTH_SUCCESS, userInfo });
            const last_path = localStorage.getItem('last_path');
            if (last_path) {
                const path = last_path.replace('login', 'dashboard').split('/').slice(0, 6).join('/');
                navigate(path);
                localStorage.removeItem('last_path');
            } else {
                navigate('/dashboard')
            }
        })
    }, onError)
}

export const updateImage = (tempUrl) => dispatch => {
    dispatch({ type: UPDATE_IMAGE, tempUrl });
}